import React, { Children, PropsWithChildren } from 'react';
import { Heading } from '../Heading/Heading';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { PostTypes } from './Post.types';

type PostsListProps = {
  headingHierarchy: number;
  type: PostTypes | 'reply';
  cleanUpPeriod?: number;
};

export function PostsList({ children, headingHierarchy, type, cleanUpPeriod }: PropsWithChildren<PostsListProps>) {
  const { t } = useSonTranslation('Posts');

  // don't show list if no posts are given.
  // maybe tell user there are no posts yet here ?
  if (Children.toArray(children).length === 0) {
    return null;
  }

  return (
    <div className="posts__list-container">
      <div className="posts__heading-container">
        <Heading hierarchy={headingHierarchy} className={type === 'reply' ? 'invisible' : 'posts__heading'}>
          {t(`default.heading.list.${type}`)}
        </Heading>
        {type === 'thread' && cleanUpPeriod && (
          <span className="posts__heading-delete-info">
            {cleanUpPeriod === 1
              ? t(`default.heading.list.threadDeleteAutomaticallySingular`, { cleanUpPeriod })
              : t(`default.heading.list.threadDeleteAutomaticallyPlural`, { cleanUpPeriod })}
          </span>
        )}
      </div>
      <ul className="posts__list">
        {Children.map(children, child => (
          <li className="posts__list-item">{child}</li>
        ))}
      </ul>
    </div>
  );
}
